<template>
  <div class="evaluate-wrapper backdrop">
    <div class="common">
      <div class="evaluate-textarea">
        <textarea rows="6" v-if="repair_summary2 == ''" v-model="repair_summary" placeholder="请输入您的评论"></textarea>
        <textarea rows="6" v-else v-model="repair_summary2" placeholder="请输入您的评论"></textarea>
      </div>
      <div class="evaluate-tag">
        <span @click="rapidInput('辛苦了')">辛苦了</span>
        <span @click="rapidInput('同意')">同意</span>
        <span @click="rapidInput('已回访')">已回访</span>
        <span @click="rapidInput('需要支援')">需要支援</span>
      </div>
      <!-- 上传图片 -->
      <div class="uploadImg">
        <div class="uploadImgFile">
          <input class="uploadImg" @change="uploadFile" type="file">
        </div>
        <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
          <img class="img" :src="image" @click="previewImage(image)">
          <img class="del" @click="deleteImage(image_key)" src="../../assets/images/repairman-del.png">
        </div>
      </div>
      <!-- 预览图片 -->
      <div class="previewimg" v-if="previewFile">
        <div @click="previewclose"></div>
        <img :src="previewimg">
      </div>
      <div class="evaluate-btn">
        <button @click="addComments">确认提交</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Evaluate',
  data () {
    return {
      access_token: '', // tob access_token
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      repair_summary: '', // 报修描述
      repair_summary2: '',
      inputList: [],
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认
      maxSize: 500, // 上传图片限制最大为500kb
      formData: ''
    }
  },
  computed: {
    ...mapState(['repairId', 'userId', 'headPortrait'])
  },
  created () {
    this.getAccessToken()
  },
  methods: {
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = e.total / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              console.log(that.imageListId)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    rapidInput (input) {
      this.inputList.push(input)
      var newArr2 = []
      newArr2.push(this.repair_summary)
      var newArr = []
      for (let i = 0; i < newArr2.length; i++) {
        if (newArr.indexOf(newArr2[i]) === -1) {
          newArr.push(newArr2[i])
        }
      }
      var newArr3 = newArr.concat(this.inputList)
      this.repair_summary2 = newArr3.join('')
    },
    // 提交
    addComments () {
      let summary = ''
      if (this.repair_summary2 === '') {
        summary = this.repair_summary
      } else {
        summary = this.repair_summary2
      }
      if (summary === '') {
        this.$toast({
          message: '请输入报修描述',
          duration: 3000
        })
        return false
      }
      let imageListId = this.imageListId.join(',')
      this.axios.post('/wechat/index/addComments', {
        village_member_id: this.userId,
        repair_id: this.repairId,
        content: summary,
        image_id: imageListId,
        head_portrait: this.headPortrait
      })
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: '评价成功',
              duration: 5000
            })
            this.$router.push({name: 'RepairCenter'})
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.evaluate-textarea {
  display: flex;
  font-size: 14px;
}
.evaluate-textarea textarea {
  flex: 1;
  background-color: #f6f6f6;
  border: none;
  padding: 10px;
  outline: none;
}
.evaluate-tag {
  margin: 20px 0 15px 0;
}
.evaluate-tag span {
  padding: 5px 10px;
  background-color: #fff4e0;
  border-radius: 3px;
  color: #ce9d3d;
  font-size: 14px;
}
.evaluate-btn {
  width: 100%;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 36px;
}
.evaluate-btn button {
  flex: 1;
  margin: 0 15px;
  height: 45px;
  border-radius: 22px;
  border: none;
  background-color: #ff9a0a;
  color: #ffffff;
  letter-spacing: 2px;
  font-size: 16px;
  outline: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/Evaluate.vue